<template>
    <loading v-model:active="isLoading" :can-cancel="false" :on-cancel="onCancel" :is-full-page="fullPage" />
    <div class="container-fluid">
        <nav aria-label="breadcrumb">
            <ol class="breadcrumb">
                <li class="breadcrumb-item"><router-link to="/lead">Leads</router-link></li>
                <li class="breadcrumb-item active" aria-current="page">Editar lead</li>
            </ol>
        </nav>
        <div class="row" v-if="enable_error_list">
            <div class="col-xl-12 col-md-12 col-sm-12">
                <div class="alert alert-danger">
                    <ol>
                        <li v-for="(error, index) in errors" :key="index">{{ error[0] }}</li>
                    </ol>
                </div>
            </div>
        </div>
        <div class="row mt-4">
            <div class="col-xl-12 col-md-12 col-sm-12">
                <div class="card shadow mb-4">
                    <!-- Card Header - Dropdown -->
                    <div class="card-body">
                        <form @submit="update">
                            <div class="row mt-3">
                                <div class="col-xl-12 col-md-12 col-sm-12">
                                    <label for="">Nome*</label>
                                    <input type="text" class="form-control" placeholder="Ex: Empresa XYZ"
                                        v-model="lead.name">
                                </div>
                            </div>
                            <div class="row mt-3">
                                <div class="col-xl-6 col-md-6 col-sm-12">
                                    <label for="">E-mail*</label>
                                    <input type="text" class="form-control" placeholder="Ex: usurio@dominio.com"
                                        v-model="lead.email">
                                </div>
                                <div class="col-xl-6 col-md-6 col-sm-12">
                                    <label for="">Telefone*</label>
                                    <input type="text" class="form-control" v-model="lead.phone"
                                        v-mask="['(##) ####-####', '(##) #####-####']" placeholder="(xx)x.xxxx-xxxx">
                                </div>
                            </div>
                            <div class="row mt-2">
                                <div class="col-xl-3 col-md-3 col-sm-12">
                                    <label for="">CEP</label>

                                    <div class="input-group mb-3">
                                        <input type="text" class="form-control" placeholder="Ex: xxxxx-xxx"
                                            v-model="lead.zipcode" v-mask="['#####-###']">
                                        <div class="input-group-append">
                                            <button class="btn btn-success" type="button" id="button-addon2"
                                                @click="searchZipcode()"><i class="fa fa-search"></i>Buscar
                                                CEP</button>
                                        </div>

                                    </div>
                                </div>
                                <div class="col-xl-7 col-md-7 col-sm-12">
                                    <label for="">Endereço*</label>
                                    <input type="text" class="form-control" placeholder="Ex: Av. Paulista"
                                        v-model="lead.street">
                                </div>
                                <div class="col-xl-2 col-md-2 col-sm-12">
                                    <label for="">Nº</label>
                                    <input type="text" class="form-control" placeholder="Ex: 100"
                                        v-model="lead.number_street">
                                </div>
                            </div>
                            <div class="row mt-2">
                                <div class="col-xl-12 col-md-12 col-sm-12">
                                    <label for="">Complemento</label>
                                    <input type="text" class="form-control" placeholder="Ex: Próximo à...."
                                        v-model="lead.complement">
                                </div>
                            </div>
                            <div class="row mt-2">
                                <div class="col-xl-4 col-md-4 col-sm-12">
                                    <label for="">Bairro</label>
                                    <input type="text" class="form-control" placeholder="Ex: Centro"
                                        v-model="lead.district">
                                </div>
                                <div class="col-xl-4 col-md-4 col-sm-12">
                                    <label for="">Cidade</label>
                                    <input type="text" class="form-control" placeholder="Ex: São Paulo"
                                        v-model="lead.city">
                                </div>
                                <div class="col-xl-4 col-md-4 col-sm-12">
                                    <label for="">UF</label>
                                    <input type="text" class="form-control" placeholder="Ex: SP" v-model="lead.uf">
                                </div>
                            </div>
                             <div class="row mt-2">
                                 <div class="col-xl-12 col-md-12 col-sm-12">
                                    <label for="">Serviço</label>
                                    <input type="text" class="form-control" placeholder="Ex: Consultoria contábil"
                                        v-model="lead.service">
                                </div>
                              </div>
                               <div class="row mt-2">
                                 <div class="col-xl-6 col-md-6 col-sm-12">
                                    <label for="">Vendedor(a)</label>
                                    <input type="text" class="form-control" placeholder="Ex: Maria"
                                        v-model="lead.seller">
                                </div>
                                  <div class="col-xl-6 col-md-6 col-sm-12">
                                    <label for="">Valor médio</label>
                                    <input type="text" class="form-control" placeholder="R$ 0,00"
                                        v-model.lazy="lead.amount" v-money="money">
                                </div>
                              </div>
                             <div class="row mb-4 mt-3">
                                <div class="col-lg-12 col-xs-12 col-sm-12">
                                    <label for="">Observações</label>
                                    <editorText @update-text="updateObservation" :modelValue="lead.observation"
                                        placeholderSend="Sem observações" ref="myChild">
                                    </editorText>
                                </div>
                            </div>
                            <br><br>
                            <div class="row mt-3">
                                <div class="col-xl-12 col-md-12 col-sm-12">
                                    <button type="submit" :disabled='!isDisabled' class="btn btn-info"><i
                                            class="fa fa-save"></i> Atualizar</button>
                                    <router-link to="/lead" class="btn btn-danger ml-3"><i class="fa fa-times"></i>
                                        Cancelar</router-link>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import api from '@/api';
import { loadZipcode } from '@/api-external';
import { handleRequestErrors } from '@/handleErrors';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/css/index.css';
import { mask } from 'vue-the-mask'
import editorText from '../util/editor-text.vue';
import { VMoney } from 'v-money'

export default {

    directives: { mask,money: VMoney },
    components: { Loading, editorText },
    data() {
        return {
            isLoading: true,
            fullPage: true,
             money: {
                decimal: ',',
                thousands: '.',
                prefix: 'R$ ',
                suffix: '',
                precision: 2,
                masked: false
            },
            lead: {
                id: '',
                name: '',
                email: '',
                phone: '',
                zipcode: '',
                street: '',
                number_street: '',
                complement: '',
                district: '',
                city: '',
                uf: '',
                observation: ''
            },
            enable_error_list: false,
            errors: []
        }
    },

    computed: {
        isDisabled: function () {
            return this.lead.name != '' && this.lead.email != '' && this.lead.phone != '';
        }
    },
    mounted() {
        this.isLoading = false;
        const id = this.$route.params.id;
        this.lead.id = id;
        this.getLead();
    },
    methods: {
        onCancel() { },
        searchZipcode() {
            this.isLoading = true;
            if (this.lead.zipcode.length > 0) {
                let zipcode = this.lead.zipcode.replace(/\D/g, '');
                loadZipcode(zipcode).then((response) => {
                    this.lead.street = response.street;
                    this.lead.district = response.neighborhood;
                    this.lead.city = response.city;
                    this.lead.uf = response.state;
                    this.isLoading = false;
                }).catch(() => {
                    this.isLoading = false;
                });
            } else {
                this.isLoading = true;
                this.$notify({
                    title: "Informação",
                    text: "Informe um CEP válido",
                    type: 'info'
                });
            }
        },
        getLead() {
            api.get('/lead/' + this.lead.id)
                .then((response) => {
                    this.isLoading = false;
                    this.lead = response.data.lead;
                    this.$refs.myChild.updateTextEditor(this.lead.observation);
                }).catch(error => {
                    this.isLoading = false;
                    handleRequestErrors(error.status, error);
                })
        },
        updateObservation(observation) {
            this.lead.observation = observation;
        },
        update(event) {
            event.preventDefault();
            this.enable_error_list = false;
            this.isLoading = true;
            api.put('/lead/' + this.lead.id, this.lead)
                .then(() => {
                    this.isLoading = false;
                    this.$notify({
                        title: "Sucesso",
                        text: "Lead atualizado com sucesso!",
                        type: 'success'
                    });
                }).catch(error => {
                    this.isLoading = false;
                    if (error.status == 422) {
                        let response_errors = error.response.data.errors;
                        this.errors = response_errors;
                        this.enable_error_list = true;
                    }
                    handleRequestErrors(error.status);
                })

        }
    }
}
</script>

<style lang="scss" scoped></style>